import type { FC } from "react";
import { IoIosClose } from "react-icons/io";
import { TablaCierresCajaModal } from "../../../pages/Estadisticas/components/TablaCierresCajaModal";
import { TablaMovimientosModal } from "../../../pages/Estadisticas/components/TablaMovimientosModal";
import { useEstadisticasModal } from "./estadisticasModalHooks";
import type { EstadisticasModalProps } from "./types";

export const EstadisticasModal: FC<EstadisticasModalProps> = (props) => {
  const {
    canUseCierresCaja,
    formatDate,
    formatearNumeros,
    handleClose,
    handleCloseCierresCaja,
    handleCloseMovimientos,
    handleOpenCierresCaja,
    handleOpenMovimientos,
    metricas,
    mostrarCierresCaja,
    mostrarMovimientos,
  } = useEstadisticasModal(props);

  return (
    <>
      {mostrarMovimientos ? (
        <TablaMovimientosModal
          formatDate={formatDate}
          usuarioRuta={props.selectedRuta}
          setMostrarMovimientos={handleCloseMovimientos}
          ingresos={metricas.totalMonto1}
          salidas={metricas.totalMonto2}
        />
      ) : null}

      {mostrarCierresCaja ? (
        <TablaCierresCajaModal
          formatDate={formatDate}
          onClose={handleCloseCierresCaja}
          usuarioRuta={props.selectedRuta}
        />
      ) : null}

      <div className="w-full min-h-screen h-screen z-30 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
        <div className="bg-gray-200 w-[400px] md:w-full p-4 md:h-full rounded-md relative max-h-[90%] overflow-y-auto">
          <div className="absolute right-2 top-2 cursor-pointer bg-white rounded-[50%] p-[1px]">
            <IoIosClose size={40} onClick={handleClose} />
          </div>
          <div>
            <p>
              Saldo Actual:{" "}
              <span className="font-bold">R${formatearNumeros(metricas.saldoActual)}</span>
            </p>
            <p>
              Ultimo saldo ingresado:{" "}
              <span className="font-bold">R${formatearNumeros(metricas.saldoMasNuevo)}</span>
            </p>

            <p>
              Total Clientes: <span className="font-bold">{metricas.totalClientes}</span>
            </p>

            <p>
              Cobro del dia:{" "}
              <span className="font-bold">R${formatearNumeros(metricas.totalAbonos)}</span>
            </p>

            <p>
              Prestamos del dia:{" "}
              <span className="font-bold">R${formatearNumeros(metricas.prestamoDelDia)}</span>
            </p>
            <p>
              Gastos del dia:{" "}
              <span className="font-bold">R${formatearNumeros(metricas.gastosHoy)}</span>
            </p>
          </div>
          <div className="mt-2 flex flex-col items-start gap-2">
            <button
              type="button"
              className="bg-[#8131bd] w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
              onClick={handleOpenMovimientos}
            >
              Movimientos
            </button>

            {canUseCierresCaja ? (
              <button
                type="button"
                className="bg-[#8131bd] w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
                onClick={handleOpenCierresCaja}
              >
                Ver cierres
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};
